import styled from "@emotion/styled"

const ArticleAsideBlogPostContent = styled.div`
  font-size: 18px;
  line-height: 31px;
`

export default ArticleAsideBlogPostContent
